const options = [
    {
        'required': {
            'message': 'The ${param} is required.'
        }
    },
    {
        'email': {
            'message': 'The ${param} must be a valid email address.'
        }
    },
    {
        'minLength': {
            'message': 'A valid ${param} should contain at least ${field_value} digits.'
        }
    },
    {
        'maxLength': {
            'message': 'A valid ${param} should contain maximum ${field_value} digits.'
        }
    },
    {
        'sameAs': {
            'message': 'The ${param} does not match with the ${field_value} field.'
        }
    },
    {
        'regex': {
            'message': 'The ${param} format is invalid.'
        }
    },
    {
        'regex_password': {
            'message': 'The ${param} must contain at least one character in uppercase, lowercase, number & special character.'
        }
    }
]

import { validationMixin } from 'vuelidate'

export const FormValidationMixin = {
    mixins: [ validationMixin ],
    data() {
        return {
            validationsEnabled: ['required', 'email', 'minLength', 'maxLength', 'sameAs', 'regex', 'regex_password'],
            ignoreFrontEndValidation: false
        }
    },
    methods: {
        validateForm($e) {

            this.$v.$touch();

            if (!this.$v.$invalid) {
                $e.target.submit()
            }

        },
        getInputValidationMessages(param, param_name_overwriting = '') {

            let messages = [];

            const inputField = param.indexOf('.') > -1
                ?  param.split('.').reduce( (o,k) => o[k], this.$v)
                : this.$v[param]

            if (typeof inputField.$params !== 'object') return;

            const rules = inputField.$params

            Object.entries(rules).forEach(row => {

                const [validationRuleName, validationRulePayload] = row
                const inputEntryIsValid = inputField[validationRuleName]

                if (inputEntryIsValid || this.validationsEnabled.indexOf(validationRuleName) <= -1) return;

                let string = options[this.validationsEnabled.indexOf(validationRuleName)][validationRuleName].message
                    .replace('${param}', param_name_overwriting ? param_name_overwriting : param);

                if (validationRulePayload.min){
                    string = string.replaceAll('${field_value}', validationRulePayload.min)
                }

                if (validationRulePayload.max){
                    string = string.replaceAll('${field_value}', validationRulePayload.max)
                }

                if (validationRulePayload.eq){
                    string = string.replaceAll('${field_value}', validationRulePayload.eq)
                }

                string = string.replaceAll('_', ' ')

                messages.push(string);

            });

            return messages;

        }
    }
}
